import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MetaTagService {

  constructor(
    private readonly metaService: Meta,
    private readonly titleService: Title
  ) { }

  setMetaTags() {

    const { title, description, image, url } = environment.metaTag;

    this.titleService.setTitle(title);

    this.metaService.addTags([
      { name: 'description', content: description },
      { name: 'title', content: title },

      // Open Graph
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: image },
      { property: 'og:url', content: url },

      // Twitter
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
      { name: 'twitter:url', content: url },
    ]);


  }

}
